import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Bulma from 'bulma'
import JsonViewer from 'vue-json-viewer'
import 'wave-ui/dist/wave-ui.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createPinia } from "pinia";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import '@/assets/style/main.scss'
import '@/assets/fonts/DinCyRg-normal.js'
import '@/assets/fonts/DinCyBd-bold.js'
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@fortawesome/fontawesome-free/css/all.css'
import autocolors from "chartjs-plugin-autocolors";
import annotationPlugin from 'chartjs-plugin-annotation';
import { Chart } from "chart.js/auto";
import moment from "moment";

init().then(null)
moment.locale('ru');

async function init() {
    const Vue = createApp(App)

    await fetch(process.env.BASE_URL + "rep_cfg.json")
        .then((response) => response.json())
        .then((config) => {
            // either use window.config
            window.rep_cfg = config
            // or use [Vue Global Config][1]
            Vue.config.globalProperties.$rep_cfg = config
        })

    await fetch(process.env.BASE_URL + "news.json")
        .then((response) => response.json())
        .then((config) => {
            // either use window.config
            window.news = config
            // or use [Vue Global Config][1]
            Vue.config.globalProperties.$news = config
        })

    await fetch(process.env.BASE_URL + "config.json")
        .then((response) => response.json())
        .then((config) => {
            // either use window.config
            window.config = config
            // or use [Vue Global Config][1]
            Vue.config.globalProperties.$config = config
        })

    const pinia = createPinia()
    Vue.use(pinia)

    Vue.use(Bulma)
    const vuetify= createVuetify({
        theme: {
            themes: {
                light: {
                    dark: false,
                    colors: {
                        green: '#8BC34A'
                    }
                },
            },
        },
        icons: {
            defaultSet: 'fa',
            aliases,
            sets: {
                fa,
            }
        },
        components,
        directives
    })
    Vue.use(vuetify)

    Vue.use(JsonViewer)
    Vue.use(VCalendar, {})

    Vue.component('VueDatePicker', VueDatePicker);

    library.add(fas, far, fab)
    Vue.component('v-icon', FontAwesomeIcon)

    Vue.use(store)
    Vue.use(router)

    Chart.register(autocolors)
    Chart.register(annotationPlugin)

    Vue.mount('#app')
}
